import React from 'react';
import SvgIconContainer from '../SvgIconContainer';

export default function IconClose(props) {
  return (
    <SvgIconContainer {...props}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="currentColor"
        fillRule="nonzero"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18 1.81286L16.1871 0L9 7.18714L1.81286 0L0 1.81286L7.18714 9L0 16.1871L1.81286 18L9 10.8129L16.1871 18L18 16.1871L10.8129 9L18 1.81286Z" />
      </svg>
    </SvgIconContainer>
  );
}

IconClose.propTypes = SvgIconContainer.propTypes;
